import { jwtDecode } from 'jwt-decode';

// Provider-agnostic sessionStorage token helpers. Both providers store the
// same three tokens under the same keys

export function setTokens(
  id_token = null,
  access_token = null,
  refresh_token = null
) {
  if (id_token) sessionStorage.setItem('id_token', id_token);
  if (access_token) sessionStorage.setItem('access_token', access_token);
  if (refresh_token) sessionStorage.setItem('refresh_token', refresh_token);
}

export function clearTokens() {
  sessionStorage.removeItem('id_token');
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
}

// Returns active decoded token
export function currentSession() {
  const token = sessionStorage.getItem('id_token');
  if (!token) return null;

  return jwtDecode(token);
}
